'use client';

import type { JSX } from 'react';
import { ConfirmDialog } from '../confirm-dialog';

interface IConfirmDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  entityName: string;
  title?: string;
  isPending?: boolean;
}

export function ConfirmDeleteDialog({
  open,
  onOpenChange,
  onConfirm,
  entityName,
  title,
  isPending = false,
}: IConfirmDeleteDialogProps): JSX.Element {
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      onConfirm={onConfirm}
      title={title ?? `Delete ${entityName}`}
      description={`Are you sure you want to delete this ${entityName.toLowerCase()}? This action cannot be undone.`}
      confirmLabel="Delete"
      pendingLabel="Deleting..."
      variant="destructive"
      isPending={isPending}
      animationSrc="/lottie/delete-files.lottie.json"
    />
  );
}
